/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
export const orange = {
    50: '#FFF6E5',
    100: '#FFE5B7',
    200: '#FFD88A',
    300: '#FFC95C',
    400: '#FFBA2E',
    500: '#FFAB00',
    600: '#FFA114',
    700: '#FF8E0A',
    800: '#DA7600',
    900: '#AB5C00',
    1000: '#7D4400',
};
